import Model from '../../util/model';

export default class CountryModel extends Model {
  set selectedCountry(value) {
    this.value = { selectedCountry: value };
  }

  get selectedCountry() {
    const { selectedCountry } = this.value;
    return selectedCountry;
  }

  set countries(value) {
    this.value = { countries: value };
  }

  get countries() {
    const { countries } = this.value;
    return countries;
  }
}
